import React from 'react'
import { VStack, Slider, SliderTrack, SliderFilledTrack, SliderThumb, useBoolean } from '@chakra-ui/react'
import { RiVolumeUpLine } from 'react-icons/ri'

export const VolumeSlider = ( props ) => {
  const { value, handleVolumeChange } = props
  const [slider, setSliderOpen] = useBoolean()
  // console.log( value, "vol value" )
  return (
    <VStack
      position="relative"
    >
      {slider
        ? <Slider
          aria-label='slider-ex-3'
          orientation='vertical'
          minH="20"
          id="slider"
          value={value}
          onChange={( e ) => handleVolumeChange( e )}
          max="100"
          border="none"
          outline="none"
          boxShadow="none"
          marginTop="-80"
          {...props}
        >
          <SliderTrack
            bg="brand.backgroundLightest"
            borderRadius={2}
            h="10"
          />
          <SliderFilledTrack
            bg="brand.mainYellow"
            borderRadius={2}
            h="4px"
            w="4px"
            border="none"
            outline="none"
            overflow="hidden"
          />
          <SliderThumb
            h="10px"
            w="10px"
            bg="brand.mainYellow"
            boxShadow="none"
            border="none"
            outline="none"
          >
          </SliderThumb>
        </Slider>
        : null}
      <RiVolumeUpLine
        style={{
          display: "inline-flex",
          color: "white",
          margin: "2px 10px 0"
        }}
        onClick={setSliderOpen.toggle}
      />
    </VStack >
  )
}